import React, { memo } from 'react';
import { Box, alpha, useTheme } from '@mui/material';
import SidebarHeader from './SidebarHeader';
import CategoryLabel from './CategoryLabel';
import { getCategoryHeight } from '../../utils/ganttUtils';

const CategorySidebar = ({
  categories,
  rowNameWidth,
  totalHeight,
  renderLabel = null,
  getCategoryRowHeight = null,
  sidebarHeaderHeight = 108,
  sidebarTitle,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        left: 0,
        float: 'left',
        width: rowNameWidth,
        height: totalHeight,
        bgcolor: alpha(theme.palette.grey[50], 0.98),
        borderRight: `2px solid ${theme.palette.divider}`,
        zIndex: 300,
        pointerEvents: 'none',
      }}
    >
      {/* Category Header */}
      <SidebarHeader height={sidebarHeaderHeight} title={sidebarTitle} />

      {/* Category Names */}
      {categories.map((category, index) => {
        const categoryHeight = getCategoryRowHeight
          ? getCategoryRowHeight(category)
          : getCategoryHeight(category.tasks);

        return renderLabel
          ? renderLabel({ category, categoryHeight, index })
          : (
            <CategoryLabel
              key={category.id}
              category={category}
              categoryHeight={categoryHeight}
              index={index}
            />
          );
      })}
    </Box>
  );
};

export default memo(CategorySidebar);
